import { css } from "@emotion/react";
import { mediaQueries } from "@upsun/react-component-library/src/styles/css-utils";

export const gridCard = css`
  display: grid;
  grid-template-columns: 1fr;
  /* padding: 24px; */

  ${mediaQueries.md} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const fontSize = css`
  font-size: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  margin-bottom: 40px;

  h4 {
    margin: 0;
    margin-right: 8px;
  }

  ${mediaQueries.md} {
    margin-bottom: 0;
  }
`;

export const row = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;